import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genStyleHooks, mergeToken } from '../../theme/internal';
import genSpaceCompactStyle from './compact';

var genSpaceStyle = function genSpaceStyle(token) {
  var _componentCls;

  var componentCls = token.componentCls,
      antCls = token.antCls;
  return _defineProperty({}, componentCls, (_componentCls = {
    display: 'inline-flex',
    '&-rtl': {
      direction: 'rtl'
    },
    '&-vertical': {
      flexDirection: 'column'
    },
    '&-align': {
      flexDirection: 'column',
      '&-center': {
        alignItems: 'center'
      },
      '&-start': {
        alignItems: 'flex-start'
      },
      '&-end': {
        alignItems: 'flex-end'
      },
      '&-baseline': {
        alignItems: 'baseline'
      }
    }
  }, _defineProperty(_componentCls, "".concat(componentCls, "-item:empty"), {
    display: 'none'
  }), _defineProperty(_componentCls, "".concat(componentCls, "-item > ").concat(antCls, "-badge-not-a-wrapper:only-child"), {
    display: 'block'
  }), _componentCls));
};

var genSpaceGapStyle = function genSpaceGapStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, {
    '&-gap-row-small': {
      rowGap: token.spaceGapSmallSize
    },
    '&-gap-row-middle': {
      rowGap: token.spaceGapMiddleSize
    },
    '&-gap-row-large': {
      rowGap: token.spaceGapLargeSize
    },
    '&-gap-col-small': {
      columnGap: token.spaceGapSmallSize
    },
    '&-gap-col-middle': {
      columnGap: token.spaceGapMiddleSize
    },
    '&-gap-col-large': {
      columnGap: token.spaceGapLargeSize
    }
  });
}; // ============================== Export ==============================


export var prepareComponentToken = function prepareComponentToken() {
  return {};
};
export default genStyleHooks('Space', function (token) {
  var spaceToken = mergeToken(token, {
    spaceGapSmallSize: token.paddingXS,
    spaceGapMiddleSize: token.padding,
    spaceGapLargeSize: token.paddingLG
  });
  return [genSpaceStyle(spaceToken), genSpaceGapStyle(spaceToken), genSpaceCompactStyle(spaceToken)];
}, function () {
  return {};
}, {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: false
});